import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchWorkoutFeed } from "../data/api/feed";

export function useWorkoutFeed() {
  return useInfiniteQuery({
    queryKey: ["workoutFeed"],
    queryFn: ({ pageParam }) => fetchWorkoutFeed({ pageParam }),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
  });
}
